import Analytics from "../views/Analytics.vue";

export const parseList = val => (val ? val.split(",") : []);

export const buildAnalyticsProps = (subview, route) => ({
  subview,
  companies: parseList(route.query.companies),
  portfolios: parseList(route.query.portfolios),
  products:
    route.params.productType === "currency"
      ? parseList(route.query.currencies)
      : parseList(route.query.commodities)
});

export const makeRoute = (path, name, subview) => ({
  path,
  name,
  component: Analytics,
  props: route => buildAnalyticsProps(subview, route)
});
